module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3F33Z"))).then(() => parcelRequire('f4eak'));